<template>
  <MenuPane class="SubMenuPane"
    :isShowing="openMenus.includes(menuName)"
    :style="{ zIndex: openMenus.indexOf(menuName) }"
  >
    <div class="menu">
      <BackButton class="title" @click="openMenus.pop()">
        {{ content.title }}
      </BackButton>
      <SubMenuGrouping v-for="grouping in content.groupings || []"
        :key="grouping.title"
        :content="grouping"
      />
    </div>
    <div v-if="content.featuredItems" class="featuredItems">
      <FeaturedItem v-for="item in content.featuredItems"
        :key="item._key"
        :content="item"
        :includeDescription="false"
      />
    </div>
  </MenuPane>
</template>

<script>
import BackButton from './BackButton.vue'
import FeaturedItem from '../shared/FeaturedItem.vue'
import MenuGroupItem from '../shared/MenuGroupItem.vue'
import MenuPane from './MenuPane.vue'
import SubMenuGrouping from './SubMenuGrouping.vue'

export default {
  components: {
    BackButton,
    FeaturedItem,
    MenuGroupItem,
    MenuPane,
    SubMenuGrouping,
  },
  props: {
    menuName: {
      type: String,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    openMenus: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

.SubMenuPane {
  display: flex;
  flex-direction: column;
}

.menu, .featuredItems {
  padding-left: var(--spacing-10);
  padding-right: var(--gutter-width);
}

.menu {
  flex-grow: 1;
  background-color: white;
  padding-bottom: var(--spacing-10);
}

.title {
  padding: var(--spacing-5) 0;
  border-bottom: thin solid var(--menu-hairline-color);
}

.menuEntries {
  margin-top: var(--spacing-5);
}

.menuItem {
  --title-font-size: var(--font-size-3);
  max-width: 16rem;
}

.menuItem + .menuItem {
  margin-top: var(--spacing-11);
}

.featuredItems {
  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-10);
  padding-bottom: var(--spacing-10);
  background-color: var(--bg-color-pale-gray);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-7);
}
</style>
